import { Box, Divider, Typography } from '@mui/material';
import moment from 'moment';
import { CommonDialog, CommonDialogHeader } from '..';
import { IPermissionsContent } from '../../../types/store';

interface Props {
  permission: IPermissionsContent | null;
  isOpen: boolean;
  onClose: () => void;
}

export const ViewPermissionDialog = ({ permission, isOpen, onClose }: Props) => {
  if (!permission) return null;

  const rows = [
    { label: 'ID', value: String(permission.id) },
    { label: 'Name', value: permission.name },
    { label: 'Description', value: permission.description ?? '—' },
    {
      label: 'Created At',
      value: permission.created_at
        ? moment(permission.created_at).format('MMMM Do YYYY, h:mm:ss a')
        : '—',
    },
    {
      label: 'Updated At',
      value: permission.updated_at
        ? moment(permission.updated_at).format('MMMM Do YYYY, h:mm:ss a')
        : '—',
    },
  ];

  return (
    <CommonDialog
      isOpen={isOpen}
      header={<CommonDialogHeader title={permission.name} onClose={onClose} />}
      body={
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          {rows.map(({ label, value }) => (
            <Box key={label}>
              <Typography variant="caption" color="text.secondary" fontWeight={600}>
                {label}
              </Typography>
              <Typography variant="body2">{value}</Typography>
              <Divider sx={{ mt: 1 }} />
            </Box>
          ))}
        </Box>
      }
      footer={undefined}
    />
  );
};
